import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import StatusItemLink from "components/StatusIcons/StatusItemLink";

import CNPStatusItem from "./CNPStatusItem";
import RegistrationStatusItem from "./RegistrationStatusItem";

const RegistrationStatusItemsForTerm = ({ termRegistration }) => {
  if (termRegistration.inPopover) {
    return (
      <PopoverItem>
        <StatusItemLink to="/academics">
          <RegistrationStatusItem
            registrationStatus={termRegistration.registrationStatus}
            termName={termRegistration.termName}
          />

          <CNPStatusItem cnpStatus={termRegistration.cnpStatus} />
        </StatusItemLink>
      </PopoverItem>
    );
  }

  return null;
};

RegistrationStatusItemsForTerm.propTypes = {
  termRegistration: PropTypes.object,
};

const PopoverItem = styled.li`
  list-style-type: none;
`;

export default RegistrationStatusItemsForTerm;
